const FORM_STEP_KEY = {
  HOME                       : 'home',
  TYPE_OF_SERVICES           : 'typeOfService',
  AREA_OF_EXPERTISE          : 'areaOfExpertise',
  COLLABORATION_TYPE         : 'collaborationType',
  NUMBER_OF_ENGINEERS_NEEDED : 'numberOfEngineersNeeded',
  CUSTOMER_NAME              : 'customerName',
  CUSTOMER_COMPANY_NAME      : 'customerCompanyName',
  CUSTOMER_EMAIL_ADDRESS     : 'customerEmailAddress',
  CUSTOMER_EXTRA_INFORMATION : 'customerExtraInformation',
  CUSTOMER_PHONE_NUMBER      : 'customerPhoneNumber',
  GDPR_CONSENT               : 'gdprConsent',
  SUBMIT                     : 'submit'
};

const FORM_STEP_ORDER = [
  FORM_STEP_KEY.HOME,
  FORM_STEP_KEY.TYPE_OF_SERVICES,
  FORM_STEP_KEY.AREA_OF_EXPERTISE,
  FORM_STEP_KEY.COLLABORATION_TYPE,
  FORM_STEP_KEY.NUMBER_OF_ENGINEERS_NEEDED,
  FORM_STEP_KEY.CUSTOMER_NAME,
  FORM_STEP_KEY.CUSTOMER_COMPANY_NAME,
  FORM_STEP_KEY.CUSTOMER_EMAIL_ADDRESS,
  FORM_STEP_KEY.CUSTOMER_EXTRA_INFORMATION,
  FORM_STEP_KEY.CUSTOMER_PHONE_NUMBER,
  FORM_STEP_KEY.GDPR_CONSENT,
  FORM_STEP_KEY.SUBMIT
];

const NO_REGISTER = 'NO_REGISTER';

export {
  FORM_STEP_KEY,
  FORM_STEP_ORDER,
  NO_REGISTER
};
